module.exports = __webpack_public_path__ + "img/77416.e628a4fc.svg";